export default "__VITE_ASSET__CvZSQmsQ__"